import {
  IconButton,
} from "@mui/material";
import React, { Fragment, useContext, useState } from "react";
import {
  FiEdit,
  FiHome,
} from "react-icons/fi";
import { AssetLocation } from "../../../logic/api";
import { SessionContext } from "../../../utility/useSession";
import flex from "../../../styles/flex";
import styles from "./styles";
import propTypes from "prop-types";
import { useTranslation } from "react-i18next";

const CarParkListItem: React.FunctionComponent<{
  carPark: AssetLocation;
  onEdit: (carPark: AssetLocation) => void;

}> = (props) => {
  const [carPark] = useState(props.carPark);

  const session = useContext(SessionContext);
  const { t } = useTranslation();


  if (session.current.site == null) {
    return <Fragment />;
  }


  return (
    <Fragment>
      <div
        style={{ ...styles.bookingListItem, opacity: carPark.active == true ? 1 : 0.5 }}
      >
        <div
          style={{
            ...flex.flexRows,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={flex.flexAuto}>
            <div>
              <IconButton disabled={true}>
                <FiHome />
              </IconButton>
            </div>
          </div>
          <div style={{ ...flex.flexFill, textAlign: "left" }}>
            <div>
              <b>
                {carPark.name}
              </b>

            </div>
          </div>
          <div style={{ ...flex.flexFill, textAlign: "left" }}>
            <div>
              <div>{t("admin.sitecode")}</div>
              <b>
                {carPark.code}
              </b>

            </div>
          </div>



          <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>

            <IconButton
              onClick={() => {
                props.onEdit(carPark);
              }}
            >
              <FiEdit />
            </IconButton>
            <div>
              <small>{t("general.edit")}</small>
            </div>

          </div>



        </div>
      </div>
    </Fragment>
  );
};

CarParkListItem.propTypes = {
  carPark: propTypes.any.isRequired,
  onEdit: propTypes.func.isRequired
};

export default CarParkListItem;
